const brandText = "font-rubik uppercase tracking-wide";
const logoText = "font-inter tracking-wider";
const secondaryText = "text-muted-foreground";
const errorText = "text-red-700";
const miniCapText = "text-xs uppercase font-bold text-muted-foreground";
const h1 = "text-5xl";
const h2 = "text-lg";
const hr = "h-[1px] bg-muted-foreground";
const card = "px-5 py-4 rounded-md bg-muted";
const buttonLink = "text-link hover:text-link-hover";
const pageWidth = "max-w-5xl w-full mx-auto";

const newCardBorder = "border rounded-lg";

const notebookPageGutter = "pr-5 pl-8 ml-64";

const secondaryLink =
  "underline decoration-dashed decoration-slate-600 text-slate-600 hover:text-slate-800 hover:decoration-slate-800";

export const tw = {
  brandText,
  secondaryText,
  errorText,
  miniCapText,
  h1,
  h2,
  hr,
  card,
  buttonLink,
  pageWidth,
  logoText,
  newCardBorder,
  notebookPageGutter,
  secondaryLink,
};
